import React from 'react';

/**
 * 视频文件图标组件
 * @param {Object} props - 组件属性
 * @param {string} props.width - 图标宽度，默认 '200'
 * @param {string} props.height - 图标高度，默认 '200'
 * @param {string} props.color - 主色调，默认 '#4A8DFF'
 * @param {string} props.className - 自定义类名
 * @param {Object} props.style - 自定义样式
 */
const VideoFileIcon = ({ width = '24px', height = '24px', color = '#4A8DFF', className = '', style = {} }) => {
    const svgStyle = {
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style
    };
    return (
        <svg
            className={className}
            style={svgStyle}
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
        >
            {/* scale up inner artwork slightly to increase visible fill area */}
            <g transform="translate(512 512) scale(1.124,1.051) translate(-512 -512)">
                <path
                    d="M192.781474 26.947368h464.303158L889.263158 256v680.421053c0 33.495579-25.977263 60.631579-58.044632 60.631579H192.781474C160.714105 997.052632 134.736842 969.916632 134.736842 936.421053V87.578947C134.736842 54.083368 160.714105 26.947368 192.781474 26.947368z"
                    fill={color}
                />
                <path
                    d="M687.562105 562.256842l-269.392842 161.414737c-18.000842 10.886737-40.906105-2.209684-40.906105-23.444211v-322.829473c0-20.749474 22.905263-33.818947 40.906105-23.444211l269.365895 161.414737c17.461895 10.886737 17.461895 36.513684 0 46.888421z"
                    fill="#FFFFFF"
                />
                <path
                    d="M657.111579 26.947368L889.263158 256h-181.894737c-33.495579 0-50.256842-13.662316-50.256842-47.157895V26.947368z"
                    fill="#CAD1F8"
                />
            </g>
        </svg>
    );
};

export default VideoFileIcon;
